module.exports = __webpack_public_path__ + "static/media/Heet.d4873389.png";